import * as constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getRecommendationRegistries.success: {
            return action.payload;
        }

        case constants.getRecommendationRegistries.try:
        case constants.getRecommendationRegistries.error: {
            return initialState;
        }

        default:
            return state;
    }
}
